import registry from './languages.json';
import greek from './catalogs/el.json';
import english from './catalogs/en.json';

// A draft can be translated/imported without appearing in the account menu.
export const LANGUAGES = registry.languages;
const catalogs = {en: english.messages, el: greek.messages};
export const previewEnabled = () => process.env.REACT_APP_GREEK_PREVIEW === 'true';
export const publishedLanguages = () => Object.keys(LANGUAGES).filter(code => (LANGUAGES[code].status === 'published' || (LANGUAGES[code].status === 'preview' && previewEnabled())));
export function normalizeLanguage(value, {allowDraft = false} = {}) {
  const code = String(value || '').trim().toLowerCase().split(/[-_]/)[0];
  return LANGUAGES[code] && (allowDraft || (LANGUAGES[code].status === 'published' || (LANGUAGES[code].status === 'preview' && previewEnabled()))) ? code : registry.default;
}
export function message(id, language, fallback, vars, catalogOverride) {
  const code = normalizeLanguage(language, {allowDraft: true});
  const candidate = (catalogOverride || catalogs[code] || {})[id];
  return formatMessage(typeof candidate === 'string' && candidate.trim() ? candidate : fallback, vars);
}
export function formatMessage(value, vars) {
  if (value == null || !vars) return value;
  return String(value).replace(/\{(\w+)\}/g, (match, name) => vars[name] != null ? String(vars[name]) : match);
}
export function locale(language) { return LANGUAGES[normalizeLanguage(language, {allowDraft: true})].locale; }
export function pluralCategory(count, language) { return new Intl.PluralRules(locale(language)).select(count); }
export function formatDate(date, language, options) { return new Intl.DateTimeFormat(locale(language), options).format(new Date(date)); }
// Format only the scheduler's declared interval label, keeping its value exact.
export function intervalLabel(value, language) {
  if (!['de','el'].includes(normalizeLanguage(language))) return value;
  const match = String(value || '').match(/^(\d+(?:\.\d+)?) (days?|months?|years?)$/);
  if (!match) return value;
  const unit = match[2].replace(/s$/, '');
  const decimals = (match[1].split('.')[1] || '').length;
  return new Intl.NumberFormat(locale(language), {style:'unit', unit, unitDisplay:'long',
    minimumFractionDigits:decimals, maximumFractionDigits:decimals}).format(Number(match[1]));
}
